<div class="p-mr-2">
  <!-- Circular Image -->
  <div class="logo-container">
    <img
      [src]="filePath"
      src="assets/images/upload-image.jpg"
      (error)="onImageError($event)"
      [class.logo-image-default]="isDefaultImage"
      class="logo-image"
      alt="Project logo"
    />
    <span>
      <button
        *ngIf="!isAttached"
        pButton
        icon="pi pi-camera"
        class="p-button-secondary p-button-rounded logo-upload-button"
        (click)="fileInput.click()"
      >
        <input
          #fileInput
          accept="image/*"
          type="file"
          (change)="chooseImage($event)"
          style="display: none"
        />
      </button>
      <button
        *ngIf="isAttached"
        pButton
        icon="pi pi-times"
        class="p-button-danger p-button-rounded logo-upload-button"
        (click)="resetImageSelected()"
      ></button>
    </span>
  </div>
</div>
